import { Link } from "react-router-dom";
import { PageHero } from "../components/common/SectionHeading";
import { ROUTES } from "../config/routes";
import { usePageTitle } from "../lib/usePageTitle";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    points: [
      "CARLINK QR codes contain only a CARLINK ID. They never contain an owner's name or phone number.",
      "People who scan a CARLINK sticker are not shown the owner's personal phone number.",
      "Information submitted through our contact form is stored securely and used only to respond to you.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    points: [
      "CARLINK stickers may only be activated and assigned by CARLINK.",
      "Stickers can be deactivated or retired if they are damaged, misused or the vehicle changes hands.",
      "Communication features are being introduced in stages and will be described here as they launch.",
    ],
  },
};

export default function LegalPage({ kind }) {
  const c = CONTENT[kind];
  usePageTitle(c.title);
  return (
    <>
      <PageHero label="Legal" title={c.title} body="Full legal text will be published before public launch. Key principles are summarised below." />
      <section className="section-pad !pt-16">
        <div data-testid={`legal-${kind}`} className="container-x max-w-3xl">
          <ul className="space-y-5">
            {c.points.map((p) => <li key={p} className="border-l-2 border-[#FF5500] pl-5 text-slate-300">{p}</li>)}
          </ul>
          <p className="mt-12 text-sm text-slate-500">Questions? <Link to={ROUTES.CONTACT} className="text-[#FF5500] hover:underline">Contact us</Link>.</p>
        </div>
      </section>
    </>
  );
}
